import * as React from "react";
const SvgFiBrandsTripadvisor = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#151A2D"
      d="M22.038 8.783 24 6.649h-4.35a13.5 13.5 0 0 0-7.652-2.354c-2.841 0-5.463.868-7.637 2.354H0l1.962 2.134a5.995 5.995 0 1 0 8.115 8.829l1.922 2.092 1.922-2.091a5.998 5.998 0 0 0 10.073-4.399 5.97 5.97 0 0 0-1.956-4.431m-16.035 8.49a4.057 4.057 0 1 1 0-8.115 4.057 4.057 0 0 1 0 8.115M12 13.097c0-2.67-1.942-4.962-4.504-5.941a11.7 11.7 0 0 1 4.502-.901c1.596 0 3.118.32 4.504.9-2.56.982-4.502 3.272-4.502 5.942m5.995 4.176a4.057 4.057 0 1 1-.001-8.115 4.057 4.057 0 0 1 .001 8.115m0-6.187a2.127 2.127 0 1 0 0 4.253 2.127 2.127 0 0 0 0-4.253M8.13 13.215a2.127 2.127 0 1 1-4.253 0 2.127 2.127 0 0 1 4.253 0"
    />
  </svg>
);
export default SvgFiBrandsTripadvisor;
